import React, { useEffect, useState } from "react";
import { auth, db } from "../firebaseConfig";
import { useAuthState } from "react-firebase-hooks/auth";
import { doc, getDoc, collection, getDocs, deleteDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { FiCheckCircle, FiTrash2, FiAlertCircle } from "react-icons/fi";
import "./adminReview.css";


const AdminReview = () => {
  const [user, loading] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [pendingBlogs, setPendingBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login");
      return;
    }

    const checkAdmin = async () => {
      try {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists() && userSnap.data().role === "admin") {
          setIsAdmin(true);
          fetchPendingBlogs(); // ✅ Only call when admin
        } else {
          setIsAdmin(false);
        }
      } catch (error) {
        console.error("Error checking admin role:", error);
      }
    };

    checkAdmin();
  }, [user, loading, navigate]);

  const fetchPendingBlogs = async () => {
    try {
      const blogsRef = collection(db, "pendingBlogs");
      const snapshot = await getDocs(blogsRef);
      
      console.log("Fetched Documents:", snapshot.docs.length);

      const blogsList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      console.log("Parsed Blogs:", blogsList);

      setPendingBlogs(blogsList);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  const approveBlog = async (id, blog) => {
    try {
      const { id: blogId, ...blogData } = blog; // ✅ Remove `id` field before saving

      await setDoc(doc(db, "publishedBlogs", id), {
        ...blogData,
        timestamp: blog.timestamp || new Date(), // ✅ Ensure timestamp exists
      });

      await deleteDoc(doc(db, "pendingBlogs", id));

      setPendingBlogs(pendingBlogs.filter(b => b.id !== id));
    } catch (error) {
      console.error("Error approving blog:", error);
    }
  };

  const deleteBlog = async (id) => {
    try {
      await deleteDoc(doc(db, "pendingBlogs", id));
      setPendingBlogs(pendingBlogs.filter(blog => blog.id !== id));
    } catch (error) {
      console.error("Error deleting blog:", error);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="admin-container">
      <h2 className="admin-title">Admin Review Panel</h2>
      {!isAdmin ? (
        <p className="access-denied" style={{ display: "flex", alignItems: "center", gap: "8px" }}><FiAlertCircle /> Access Denied: You are not an admin.</p>
      ) : (
        <>
          <h3 className="admin-title">Pending Blogs for Review</h3>
          {pendingBlogs.length === 0 ? (
            <p className="no-blogs">No blogs pending review.</p>
          ) : (
            <div className="blog-list">
              {pendingBlogs.map(blog => (
                <div key={blog.id} className="blog-card">
                  <h4 className="blog-title">{blog.title}</h4>
                  <p className="blog-content">{blog.content}</p>
                  <p className="blog-author"><b>Author:</b> {blog.author}</p>
                  <div className="button-container">
                    <button onClick={() => approveBlog(blog.id, blog)} className="approve-btn"><FiCheckCircle style={{ marginRight: "6px" }} /> Approve</button>
                    <button onClick={() => deleteBlog(blog.id)} className="delete-btn"><FiTrash2 style={{ marginRight: "6px" }} /> Delete</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
  
};

export default AdminReview;
